const FlexSearch = require("flexsearch");

var index;

export function initializeSearchIndex(seniorityList) {
  index = new FlexSearch({
    doc: {
      id: "eid",
      profile: "speed",
      field: {
        shortName: {},
        lastName: {},
        declaration: {},
      },
    },
  });

  index.add(seniorityList);
}

export function searchDeclarations({ searchString, applySearchCallback }) {
  if (index) {
    let result = index.where(
      function (item) {
        if (item.eid.toLowerCase().includes(searchString)) {
          return true;
        }

        if (item.shortName.toLowerCase().includes(searchString)) {
          return true;
        }

        if (item.lastName.toLowerCase().includes(searchString)) {
          return true;
        }

        if (item.ftpt?.toLowerCase().includes(searchString)) {
          return true;
        }

        if (item.declaration?.toLowerCase().includes(searchString)) {
          return true;
        }

        return false;
      },
      (result) => {
        applySearchCallback(searchString, result);
      }
    );
    applySearchCallback(searchString, result);
  }
}
